import { CodeValidationPage } from './../portability-keys/code-validation/code-validation.page';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
// import { UserProfile } from './../../../../../../../core/dto/user-profile';
// import { AuthService } from './../../../../../../../core/auth/auth-service';
import { NavController, ModalController, ToastController } from '@ionic/angular';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { RegisterKeyService, ClaimsKeysPixService } from '@wlp/ui-bs-pix';
import { ModalPixManagementKeyComponent } from '../../../../modals/modal-pix-management-key/modal-pix-management-key.component';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { ClipboardService } from 'ngx-clipboard';
import { PixClaimTransferValidationDto } from '@wlp/ui-bs-pix/lib/dto/pix-claim-validation-transfer-request.dto';
import { UserInfoProfile, UserInfoService } from '@wlp/ui-bs-login';
import { Subject } from 'rxjs';
import { ModalService } from 'src/app/core/shared/services/modal.service';
import * as moment from 'moment';


@Component({
  selector: 'app-manage-keys',
  templateUrl: './manage-keys.page.html',
  styleUrls: ['./manage-keys.page.scss', '../skeleton-pix-base/skeleton-pix-base.page.scss'],
})
export class ManageKeysPage implements OnInit, OnDestroy {
  backgroundImage: string;
  userProfile: UserInfoProfile;
  listKeys: [];
  dataRegister: any;
  cdr: any;
  keyPix: string;
  keyTypePix: string;
  uuidKey: string;
  statusOrigin: string;

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private navController: NavController,
    private registerKeyService: RegisterKeyService,
    protected authService: UserInfoService,
    private load: LoadingService,
    private router: Router,
    private modalController: ModalController,
    private translate: UiBsTranslateService,
    private clipboardService: ClipboardService,
    private toastController: ToastController,
    private claimsKeyService: ClaimsKeysPixService,
    private modalService: ModalService,
  ) {
    this.backgroundImage = this.layoutConfigService.getConfig('wlTheme.header.background.image');
    this.dataRegister = new Date();
  }

  private destroy$: Subject<null> = new Subject();

  ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    this.loadUser();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadUser() {
    this.authService.getInfoProfile().then(
      (res) => {
        this.userProfile = res;
        if (this.userProfile) {
          this.load.hide();
          this.getListKey();
        }
      },
      () => {
        this.load.hide();
        this.cdr.detectChanges();
      }
    );
  }

  goToRegisterKey() {
    this.navController.navigateRoot(['app/pix/register-key-pix']);
  }

  public async deleteKey(ev) {
    const key: any = this.listKeys.find((key: any) => {
      return key.keyValue === ev;
    });

    const isConfirmed = await this.showConfirmationAlert(`Tem certeza que deseja remover a chave ${key.keyValue}?`, 'Ok', 'Cancelar');

    if (isConfirmed) {
      this.load.show();

      this.registerKeyService.deleteKey(this.userProfile.uuidAccount, key.uuid).subscribe((res) => {
        if (res.status === 'SUCCESS') {
          this.load.hide();
          this.listKeys.pop();
          this.showNotification('success', 'Sucesso!', this.translate.applyTranslate(`PIX.PIX_MANAGE_KEYS.MESSAGES.REMOVE_KEY`));
          if (this.listKeys.length >= 1) {
            this.getListKey();
          } else {
            this.navController.navigateRoot('/app/pix');
          }
        } else {
          this.load.hide();
          this.showNotification('warning-circle', 'Atenção!', this.translate.applyTranslate(`PIX.PIX_MANAGE_KEYS.MESSAGES.FAILED`));
        }
      });
    }
  }

  claimKey(key: any) {
    let resolutionKeyDate: string;
    if (key.resolutionPeriod === null) {
      resolutionKeyDate = 'breve';
    } else {
      resolutionKeyDate = moment(key.resolutionPeriod).format('DD/MM/YYYY');
    }
    this.keyPix = key.keyValue;
    this.keyTypePix = key.typeKey;
    this.uuidKey = key.uuid;
    this.statusOrigin = key.origin;

    const params = {
      resolutionDate: resolutionKeyDate,
    };

    switch (this.statusOrigin) {
      case 'EXTERNAL':
        this.modalClaimKey(
          null,
          'PIX.PIX_REGISTER_KEY.MESSAGES.MESSAGE_CLAIM_PORTABILITY',
          'Ceder Chave',
          'Confirmar posse',
          true,
          'warning-circle',
          false,
          false,
          params,
          'modal-pix-management-key-class-medium'
        ).then((res) => {
          if (res.data.dismissed === true) {
            /* CEDER CHAVE */
            this.claimsKeyService.claimsDonor(key.uuid).subscribe((res) => {
              if (res.status === true) {
                this.load.hide();
                this.showNotification('success', 'Sucesso!', res.message);
                this.cdr.detectChanges();
              } else {
                this.load.hide();
                this.showNotification('warning-circle', 'Atenção!', res.message);
              }
            });
          }
          if (res.data.dismissed === false) {
            /* CONFIRMAR POSSE DA CHAVE */
            this.load.hide();
            this.presentModalValidation();
          }
        });
        break;
      case 'PLATFORM':
        this.modalClaimKeyCancel(
          null,
          'PIX.PIX_REGISTER_KEY.MESSAGES.MESSAGE_CLAIM_PORTABILITY',
          'Cancelar solicitação',
          true,
          'warning-circle',
          false,
          false,
          params,
          'modal-pix-management-key-class-medium'
        ).then(async (res) => {
          if (res.data.dismissed === true || 'false') {

            const isConfirmed = await this.showConfirmationAlert(`Tem certeza que deseja cancelar a solicitação da chave: ${key.keyValue}?`, 'Ok', 'Cancelar');

            if (isConfirmed) {
              const claimTranferValidation: PixClaimTransferValidationDto = {
                uuidClaimRequest: key.uuid,
                code: '',
              }
              this.claimsKeyService.claimTransferCancelRequested(claimTranferValidation).subscribe((res) => {
                if (res.status === true) {
                  this.showNotification('success', 'Sucesso!', res.message);
                  this.cdr.detectChanges();
                } else {
                  this.showNotification('warning-circle', 'Atenção!', res.message);
                }
              });
            } else {
              this.load.hide();
            }
          }
        });
        break;
    }
  }

  async presentModalValidation() {
    const modalCodevalidation = await this.modalController.create({
      component: CodeValidationPage,
      componentProps: {
        key: this.keyPix,
        type: this.keyTypePix,
      },
    });
    modalCodevalidation.present();

    modalCodevalidation.onDidDismiss().then((data) => {
      let body = {
        uuidClaimRequest: this.uuidKey,
        code: data.role,
      };
      if (data.data) {
        this.claimsKeyService.claimsValidation(body).subscribe((res) => {
          if (res.status === true) {
            this.showNotification('success', 'Sucesso!', res.message);
            this.cdr.detectChanges();
          } else {
            this.showNotification('warning-circle', 'Atenção!', res.message);
          }
        });
      }
    });
  }

  getListKey() {
    try {
      this.load.show();
      this.registerKeyService.getAllKey(this.userProfile.uuidAccount).subscribe((res) => {
        this.listKeys = res.data;
        this.load.hide();
      });
    } catch (error) {
      this.load.hide();
    }
  }

  async modalClaimKeyCancel(
    title: string,
    subtitle: string,
    confirmText: string,
    imageModal: boolean,
    imageTag: string,
    doubleButton: boolean,
    clearButton: boolean,
    params: Object,
    classModal?
  ) {
    const modal = await this.modalController.create({
      component: ModalPixManagementKeyComponent,
      cssClass: classModal ? classModal : 'modal-pix-management-key-class-claim',
      componentProps: {
        title,
        subtitle,
        confirmText,
        imageModal,
        imageTag,
        doubleButton,
        clearButton,
        params,
      },
    });
    await modal.present();
    return await modal.onWillDismiss();
  }

  async modalClaimKey(
    title: string,
    subtitle: string,
    dismissText: string,
    confirmText: string,
    imageModal: boolean,
    imageTag: string,
    doubleButton: boolean,
    clearButton: boolean,
    params: Object,
    classModal?
  ) {
    const modal = await this.modalController.create({
      component: ModalPixManagementKeyComponent,
      cssClass: classModal ? classModal : 'modal-pix-management-key-class-claim',
      componentProps: {
        title,
        subtitle,
        dismissText,
        confirmText,
        imageModal,
        imageTag,
        doubleButton,
        clearButton,
        params,
      },
    });
    await modal.present();
    return await modal.onWillDismiss();
  }

  goBack() {
     this.navController.navigateRoot('/app/dashboard');
  }

  public getImageTag(tag: string) {
    let item: any = this.layoutConfigService.getImagesPages(tag);
    return item.path;
  }

  copyLink(key: any) {
    this.clipboardService.copyFromContent(key.keyValue)
      ? this.toastPresent('PIX.DASHBOARD.TO_COPY_KEY.SUCCESS', 2000, 'top')
      : this.toastPresent('PIX.DASHBOARD.TO_COPY_KEY.FAILED', 2000, 'top');
  }

  async toastPresent(message, duration, position) {
    const toast = await this.toastController.create({
      message: this.translate.applyTranslate(message),
      duration,
      position,
    });
    toast.present();
  }

  private async showNotification(status: string, message: string, description: string) {
    await this.modalService.notificationAlert({
      status: status,
      message: message,
      confirmation: false,
      description: description,
      confirmBtn: 'Ok',
      translate: true,
      backdropDismiss: false,
    });
  }

  private async showConfirmationAlert(description: string, confirmBtn: string, cancelBtn: string): Promise<boolean> {
    return await this.modalService.confirmationAlert({
      status: 'warning-circle',
      message: 'Atenção!',
      confirmation: true,
      description: description,
      confirmBtn: confirmBtn,
      cancelBtn: cancelBtn,
      translate: true,
      backdropDismiss: false,
    });
  }
}
